import React, { useEffect } from "react";
import AOS from "aos";
import { useNavigate } from "react-router-dom";
import "aos/dist/aos.css";
import SectionHeader from "../../components/ui/HeaderSection";
import ThemesCard from "../../components/ui/ThemesCard";

const ThemeSection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  const handleViewMore = () => {
    navigate("/themes-detail");
  };

  return (
    <section
      id="theme-section"
      className="pt-16 pb-6 px-4 md:px-10 bg-[#FEF3F9]"
    >
      {/* Header Section */}
      <div className="flex flex-col items-center text-center mb-12">
        <div data-aos="fade-up" data-aos-duration="1000">
          <SectionHeader
            title="Temukan Tema Terbaikmu"
            description="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
            TitleColor="#49516F"
          />
        </div>
      </div>

      {/* ThemesCard Container */}
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-12 lg:px-3 pb-12 max-w-screen-lg mx-auto"
        data-aos="fade-up"
      >
        <ThemesCard ribbonType="vip" data-aos="zoom-in" />
        <ThemesCard ribbonType="basic" data-aos="zoom-in" />
        <ThemesCard ribbonType="vip" data-aos="zoom-in" />
        <ThemesCard ribbonType="premium" data-aos="zoom-in" />
        <ThemesCard ribbonType="premium" data-aos="zoom-in" />
        <ThemesCard ribbonType="premium" data-aos="zoom-in" />
      </div>

      {/* Link "Lihat lebih banyak tema" */}
      <div className="text-center" data-aos="fade-up" data-aos-delay="200">
        <button
          className="text-[#007BFF] text-[14px] font-semibold font-[Montserrat] bg-transparent border-none cursor-pointer hover:text-[#0056b3] transition-colors duration-300"
          onClick={handleViewMore}
        >
          Lihat lebih banyak tema disini!
        </button>
      </div>
    </section>
  );
};

export default ThemeSection;
